module.exports = __webpack_public_path__ + "img/student.0637c15a.png";